import * as React from 'react';
import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';

/** Public path — same asset as `web/public/favicon.svg` (tab icon). */
export const FAVICON_PATH = '/favicon.svg';

export type BrandMarkProps = Omit<BoxProps, 'component' | 'src' | 'alt' | 'children'> & {
  size?: number;
  alt?: string;
};

/** Rasterised product mark for headers, sidebars, and login screens. */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 28, alt = 'Workflow.Estate', sx, ...rest }) => {
  const radiusPx = Math.max(2, Math.round((size * 96) / 512));
  return (
    <Box
      component="img"
      src={FAVICON_PATH}
      alt={alt}
      sx={{
        width: size,
        height: size,
        display: 'block',
        flexShrink: 0,
        borderRadius: `${radiusPx}px`,
        ...sx,
      }}
      {...rest}
    />
  );
};

export default BrandMark;
